import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import urlBase from '../../url-base';
import moment from 'moment';

export default function(dados, tipo) {

	const { vfs } = vfsFonts.pdfMake;
	pdfMake.vfs = vfs;
	let responsavel = dados.financialManager;
	let vendas = dados.sales;
	let holder = dados.holder;
	let dependentes = dados.dependents;
	let plan = dados.plan;

	// NOVO: Busca os planos direto da API caso não venham em dados
    var filtros = {"status":"ATIVO", "publish":true};
    var url = `${urlBase.loopBack}Plans?filter={"where":${JSON.stringify(filtros)}}`;

	let planosCorrelacionados = dados.planos_correlacionados || [];

	// Função auxiliar para continuar a montagem do PDF após o fetch (se necessário)
	function prosseguirGeracao(planosCorrelacionadosAtualizados) {
		planosCorrelacionados = planosCorrelacionadosAtualizados;

		let paymentType = "";
		let tipoPagamento = "";
		if (vendas.planServer || vendas.paymentType === "server") {
			paymentType = "server";
			tipoPagamento = "DESCONTO EM FOLHA";
		} else {
			if ( vendas.paymentType === "card" || responsavel.cardNumber != "" ) {
				paymentType = "card";
				tipoPagamento = "CARTÃO DE CRÉDITO";
			} else {
				paymentType = "ticket";
				tipoPagamento = "BOLETO";
			}
		}

		/**
		 * Montar tabela do responsável financeiro
		 * @returns 
		 */
		function ResponsavelFinanceiro() {
			let body = [];
			let dataRow = [];
			let nascimento = moment(responsavel.dateOfBirth).format('DD/MM/YYYY');

			dataRow = [];
			dataRow.push({ text: "RESPONSÁVEL FINANCEIRO ", colSpan: 5, style: 'styleTitulo' }, {}, {}, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "NOME", style: 'styleCampo' }, { text: "CPF", style: 'styleCampo' }, { text: "RG", style: 'styleCampo' }, { text: "DATA DE NASC.:", colSpan: 2, style: 'styleCampo' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: responsavel.firstName, style: 'styleDados' }, { text: responsavel.cpf, style: 'styleDados' }, { text: responsavel.rg, style: 'styleDados' }, { text: nascimento, colSpan: 2, style: 'styleDados' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "MÃE", style: 'styleCampo' }, { text: "ESTADO CIVIL", style: 'styleCampo' }, { text: "CARTÃO DO SUS", style: 'styleCampo' }, { text: "TELEFONE", colSpan: 2, style: 'styleCampo' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: responsavel.motherName, style: 'styleDados' }, { text: responsavel.maritalStatus, style: 'styleDados' }, { text: responsavel.susNumber, style: 'styleDados' }, { text: responsavel.homePhone, colSpan: 2, style: 'styleDados' }, {});
			body.push(dataRow);

			dataRow = [];
			dataRow.push({ text: "E-MAIL", style: 'styleCampo' }, { text: "CELULAR 1", style: 'styleCampo' }, { text: "CELULAR 2", colSpan: 3, style: 'styleCampo' }, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: responsavel.email, style: 'styleDados' }, { text: responsavel.cellPhone, style: 'styleDados' }, { text: responsavel.cellPhone2, colSpan: 3, style: 'styleDados' }, {}, {});
			body.push(dataRow);
			if( vendas.planServer ) {
				dataRow = [];
				dataRow.push({ text: "EMPRESA", style: 'styleCampo' }, { text: "MATRÍCULA SERVIDOR", colSpan: 4, style: 'styleCampo' }, {}, {}, {});
				body.push(dataRow);
				dataRow = [];
				dataRow.push({ text: responsavel.codOrgao, style: 'styleDados' },  { text: responsavel.matServidor, colSpan: 4, style: 'styleDados' }, {}, {}, {});
				body.push(dataRow);			
			}
			return body;
		}

		/**
		 * Monta a tabela de ENDEREÇO
		 * @returns 
		 */
		function Endereco() {
			let body = [];
			let dataRow = [];

			dataRow = [];
			dataRow.push({ text: "ENDEREÇO ", colSpan: 5, style: 'styleTitulo' }, {}, {}, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "RUA", style: 'styleCampo' }, { text: "BAIRRO", style: 'styleCampo' }, { text: "CIDADE", style: 'styleCampo' }, { text: "UF", colSpan: 2, style: 'styleCampo' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: responsavel.address, style: 'styleDados' }, { text: responsavel.bairro, style: 'styleDados' }, { text: responsavel.municipio, style: 'styleDados' }, { text: responsavel.estado, colSpan: 2, style: 'styleDados' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "CEP", style: 'styleCampo' }, { text: "COMPLEMENTO", style: 'styleCampo' }, { text: "Nº", colSpan: 3, style: 'styleCampo' }, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: responsavel.cep, style: 'styleDados' }, { text: responsavel.addressComplement, style: 'styleDados' }, { text: responsavel.addressNumber, colSpan: 2, style: 'styleDados' }, {}, {});
			body.push(dataRow);

			return body;
		}

		/**
		 * Montar da tabela do titular
		 * @returns 
		 */
		function Titular() {
			let body = [];
			let portabilidade = ( holder.portability ? "SIM" : "NÃO");
			let dataRow = [];
			let nascimento = moment(holder.dateOfBirth).format('DD/MM/YYYY');
			let sexo = (holder.gender == 0 ? 'FEMININO' : 'MASCULINO');
			dataRow = [];
			dataRow.push({ text: "TITULAR ", colSpan: 5, style: 'styleTitulo' }, {}, {}, {}, {});
			body.push(dataRow);

			dataRow = [];
			dataRow.push({ text: "NOME", style: 'styleCampo' }, { text: "CPF", style: 'styleCampo' }, { text: "DATA NASC.", style: 'styleCampo' }, { text: "SEXO", colSpan: 2, style: 'styleCampo' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: holder.firstName, style: 'styleDados' }, { text: holder.cpf, style: 'styleDados' }, { text: nascimento, style: 'styleDados' }, { text: sexo, colSpan: 2, style: 'styleDados' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "MÃE", style: 'styleCampo' }, { text: "ESTADO CIVIL", style: 'styleCampo' }, { text: "VALOR", style: 'styleCampo' }, { text: "CARTÃO SUS", colSpan: 2, style: 'styleCampo' }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: holder.motherName, style: 'styleDados' }, { text: holder.maritalStatus, style: 'styleDados' }, { text: holder.valuePlan, style: 'styleDados' }, { text: holder.susNumber, colSpan: 2, style: 'styleDados' }, {});
			body.push(dataRow);

			dataRow = [];
			dataRow.push({ text: "PLANO", style: 'styleCampo' }, { text: "VALOR", style: 'styleCampo' }, { text: "PORTABILIDADE", style: 'styleCampo' }, { }, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push( { text: holder.planName, style: 'styleDados' }, { text: "R$ "+holder.valuePlan, style: 'styleDados' },{ text: portabilidade , style: 'styleDados' }, { }, {});
			body.push(dataRow);		
			
			return body;
		}

		/**
		 * Montar tabela de DEPENDENTES
		 * @returns 
		 */
		function Dependentes() {
			let body = [];
			let dataRow = [];
			dataRow.push({ text: "DEPENDENTES ", colSpan: 5, style: 'styleTitulo' }, {}, {}, {}, {});
			body.push(dataRow);

			if (dependentes.length <= 0) {
				dataRow = [];
				dataRow.push({ text: "SEM DEPENDENTES CADASTRADOS", colSpan: 5, style: 'styleSemDados' }, {}, {}, {}, {});
				body.push(dataRow);
			} else {
				dependentes.forEach(function (row) {
					let portabilidade = (row.portabilidade ? "SIM" : "NÃO");
					let nascimento = moment(row.dateOfBirth).format('DD/MM/YYYY');
					let sexo = (row.gender == 0 ? 'FEMININO' : 'MASCULINO');

					dataRow = [];
					dataRow.push({ text: "NOME", style: 'styleCampo' }, { text: "CPF", style: 'styleCampo' }, { text: "DATA NASC.", style: 'styleCampo' }, { text: "PARENTESCO", colSpan: 2, style: 'styleCampo' }, {});
					body.push(dataRow);
					
					dataRow = [];
					dataRow.push({ text: row.firstName, style: 'styleDados' }, { text: row.cpf, style: 'styleDados' }, { text: nascimento, style: 'styleDados' }, { text: row.parentage, colSpan: 2, style: 'styleDados' }, {});
					body.push(dataRow);

					dataRow = [];
					dataRow.push({ text: "NOME DA MÃE", style: 'styleCampo' }, { text: "SEXO", style: 'styleCampo' }, { text: "ESTADO CIVIL", style: 'styleCampo' }, { text: "CARTÃO DO SUS", colSpan: 2, style: 'styleCampo' }, {});
					body.push(dataRow);
					
					dataRow = [];
					dataRow.push({ text: row.motherName, style: 'styleDados' }, { text: sexo, style: 'styleDados' }, { text: row.maritalStatus, style: 'styleDados' }, { text: (row.susNumber == '' ? 'NÃO INFORMADO' : row.susNumber), colSpan: 2, style: 'styleDados' }, {});
					body.push(dataRow);
					
					dataRow = [];
					dataRow.push({ text: "PLANO", style: 'styleCampo' }, { text: "VALOR", style: 'styleCampo' }, { text: "PORTABILIDADE", style: 'styleCampo' }, {}, {});
					body.push(dataRow);
					
					dataRow = [];
					dataRow.push({ text: row.planName, style: 'styleDados' }, { text: row.valuePlan, style: 'styleDados' }, { text: portabilidade, style: 'styleDados' }, {}, {});
					body.push(dataRow);	

					dataRow = [];
					dataRow.push(
						{ text: "", colSpan: 5, border: [false, false, false, true], borderColor: ['#ccc', '#ccc', '#ccc', '#ccc'] }, 
						{}, {}, {}, {}
					);
					body.push(dataRow);
				});
			}
			return body;
		}	

		/**
		 * Informações do Plano
		 * @returns 
		 */
		function InfoPlano() {
			let body = [];
			let dataRow = [];
			let portabilidade = (responsavel.portability ? "SIM" : "NÃO")
			dataRow.push({ text: "INFO. DO PLANO ", colSpan: 4, style: 'styleTitulo' }, {}, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "NOME DO PLANO", style: 'styleCampo' }, 
						{ text: "VALOR TOTAL MENSAL", style: 'styleCampo' }, 
						{ text: "DATA ADESÃO.", style: 'styleCampo' }, 
						{ text: "PORTABILIDADE.", style: 'styleCampo' }
					);
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: plan.name, style: 'styleDados' }, 
						{ text: "R$ " + responsavel.responsibility, style: 'styleDados' }, 
						{ text: responsavel.dateSignatureContract, style: 'styleDados' }, 
						{ text: portabilidade, style: 'styleDados' }
					);
			body.push(dataRow);
			return body;
		}

		function Carencia() {
			let body = [];
			let dataRow = [];
			let planosMap = {};

			if (plan) {
				let idPrincipal = plan.id || plan.codeS4 || plan._id || 'principal';
				planosMap[idPrincipal] = plan;
			}

			if (dependentes && dependentes.length > 0) {
				dependentes.forEach((item) => {
					if (item.plansId && planosCorrelacionados.length > 0) {
						let encontrado = planosCorrelacionados.find(
							p => (p.id === item.plansId || p.codeS4 === item.plansId || p._id === item.plansId)
						);
						if (encontrado) {
							let idDep = encontrado.id || encontrado.codeS4 || encontrado._id;
							planosMap[idDep] = encontrado;
						}
					} else if (item.carenciaGroups && (item.planName || item.plansName)) {
						let nomePlanoDep = item.planName || item.plansName;
						planosMap[nomePlanoDep] = {
							name: nomePlanoDep,
							tradeName: nomePlanoDep,
							carenciaGroups: item.carenciaGroups
						};
					}
				});
			}

			let listaPlanosUnicos = Object.values(planosMap);

			if (listaPlanosUnicos.length === 0 && plan) {
				listaPlanosUnicos.push(plan);
			}

			if (listaPlanosUnicos.length === 0 || !listaPlanosUnicos[0].carenciaGroups) {
				dataRow.push({ text: "SEM CARÊNCIAS CONFIGURADAS PARA ESTE PLANO", colSpan: 2, style: 'styleSemDados' }, {});
				body.push(dataRow);
				return body;
			}

			listaPlanosUnicos.forEach((planoItem, planoIndex) => {
				let nomePlanoExibicao = planoItem.tradeName || planoItem.name || "PLANO";
				
				dataRow = [];
				dataRow.push({ text: `TERMO ADITIVO DE REDUÇÃO DE CARÊNCIA - ${nomePlanoExibicao.toUpperCase()}`, colSpan: 2, style: 'styleTitulo' }, {});
				body.push(dataRow);
				
				dataRow = [];
				dataRow.push({ text: "COBERTURAS", style: 'styleCarenciaTitulo' }, { text: tipoPagamento, style: 'styleCarenciaTitulo' });
				body.push(dataRow);

				if (planoItem.carenciaGroups && planoItem.carenciaGroups.length > 0) {
					planoItem.carenciaGroups.forEach(function (carencia) {
						let textoCarencia = (paymentType === "server" ? carencia.server : (paymentType === "card" ? carencia.card : carencia.ticket));

						dataRow = [];
						dataRow.push(
							{ text: carencia.name ? carencia.name.toUpperCase() : '', style: 'styleCarenciaDados1', alignment: 'left' },
							{ text: textoCarencia || 'Sem carência', style: 'styleCarenciaDados2' }
						);
						body.push(dataRow);
					});
				} else {
					dataRow = [];
					dataRow.push({ text: "SEM CARÊNCIAS CONFIGURADAS", colSpan: 2, style: 'styleSemDados' }, {});
					body.push(dataRow);
				}

				if (planoIndex < listaPlanosUnicos.length - 1) {
					dataRow = [];
					dataRow.push({ text: "", colSpan: 2, border: [false, false, false, false], fillColor: '#ffffff' }, {});
					body.push(dataRow);
				}
			});

			return body;
		}	

		function Corretora() {
			let corretora = dados.broker;
			let vendedor = dados.salesman;
			let body = [];
			let dataRow = [];
			dataRow.push({ text: "INFO. CORRETORA ", colSpan: 3, style: 'styleTitulo' }, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "NOME ", style: 'styleCampo' }, { text: "VENDEDOR", style: 'styleCampo' }, { text: "CÓDIGO", style: 'styleCampo' });
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: corretora.name, style: 'styleDados' }, { text: vendedor.user.name, style: 'styleDados' }, { text: vendedor.codeS4, style: 'styleDados' });
			body.push(dataRow);
			return body;
		}

		function DadosFinanceiros() {
			let body = [];
			let dataRow = [];
			dataRow.push({ text: "DADOS FINANCEIRO", colSpan: 3, style: 'styleTitulo' }, {}, {});
			body.push(dataRow);
			let validade = "";
			if (responsavel.cardValidity != undefined)
				validade = responsavel.cardValidity.substring(0, 2) + "/" + responsavel.cardValidity.substring(2, 6);
			let pertenceCartao ="SIM";
			if (responsavel.cpfCard == undefined) {
				pertenceCartao = "NÃO INFORMADO";
			} else {
				if (responsavel.cpfCard != '' ) 
					pertenceCartao = 'NÃO';
				else	
					pertenceCartao = 'SIM';
			}
			if (paymentType === "server") {
				dataRow = [];
				dataRow.push({ text: "DESCONTO EM FOLHA ", colSpan: 3, style: 'styleSemDados' }, {}, {});
				body.push(dataRow);			
			} else if (paymentType === "card") {
				dataRow = [];
				dataRow.push({ text: "CARTÃO DE CRÉDITO ", style: 'styleCampo' }, { text: "NOME DO TITULAR DO CARTÃO", style: 'styleCampo' }, { text: "BANDEIRA", style: 'styleCampo' });
				body.push(dataRow);
				dataRow = [];
				dataRow.push({ text: "XXXX.XXXX.XXXX."+responsavel.cardNumber.slice(-4), style: 'styleDados' }, { text: responsavel.cardHolderName, style: 'styleDados' }, { text: responsavel.cardFlag, style: 'styleDados' });
				body.push(dataRow);
				dataRow = [];
				dataRow.push({ text: "VENCIMENTO ", style: 'styleCampo' }, { text: "VALIDADE", style: 'styleCampo' }, { text: "DIA DE LANÇAMENTO DA PARCELA", style: 'styleCampo' });
				body.push(dataRow);
				dataRow = [];
				dataRow.push({ text: responsavel.cardDayExpiration, style: 'styleDados' }, { text: validade,  style: 'styleDados' }, { text: responsavel.cardDayExpiration,  style: 'styleDados' });
				body.push(dataRow);
				dataRow = [];
				if ( pertenceCartao =='NÃO' )
					dataRow.push({ text: "CARTÃO PERTENCE A ALGUM USUÁRIO DO PLANO?  " , colSpan: 2, style: 'styleCampo' }, {}, {text : "CPF DO DONO DO CARTÃO", style: 'styleCampo'});
				else
					dataRow.push({ text: "CARTÃO PERTENCE A ALGUM USUÁRIO DO PLANO? " , colSpan: 3, style: 'styleCampo' }, {}, {});
				body.push(dataRow);
				dataRow = [];
				if ( pertenceCartao =='NÃO' ) {
					dataRow.push({ text: pertenceCartao, colSpan: 2, style: 'styleDados' }, {},  {text: responsavel.cpfCard, style: 'styleDados'});
				} else {
					dataRow.push({ text: pertenceCartao, colSpan: 3, style: 'styleDados' }, {}, {});
				}
				body.push(dataRow);		
			} else {
				dataRow = [];
				dataRow.push({ text: "PAGAMENTO POR BOLETO ", colSpan: 3, style: 'styleSemDados' }, {}, {});
				body.push(dataRow);
			}
			return body;
		}

		function Documentos() {
			let body = [];
			let dataRow = [];
			let documentos = dados.imagesDoc;
			let cpf = (documentos.cpf == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
			let rg = (documentos.rg == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
			let rg2 = (documentos.rg2 == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
			let residencia = (documentos.resid == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
			let credito = (documentos.credtFrontal == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
			let portabilidade = (documentos.declarationPortability == '' ? 'NÃO ENVIADO' : 'EM ANEXO');

			dataRow.push({ text: "DOCUMENTOS", colSpan: 3, style: 'styleTitulo' }, {}, {});
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "CPF", style: 'styleCampo' }, { text: "RG", style: 'styleCampo' }, { text: "RG REVERSO", style: 'styleCampo' });
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: cpf, style: 'styleDados' }, { text: rg, style: 'styleDados' }, { text: rg2, style: 'styleDados' });
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: "COMPROVANTE DE RESIDÊNCIA ", style: 'styleCampo' }, { text: "CARTÃO DE CRÉDITO", style: 'styleCampo' }, { text: "PORTABILIDADE", style: 'styleCampo' });
			body.push(dataRow);
			dataRow = [];
			dataRow.push({ text: residencia, style: 'styleDados' }, { text: credito, style: 'styleDados' }, { text: portabilidade, style: 'styleDados' });
			body.push(dataRow);

			return body;
		}

		function tableResponsavel() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', 150, 80, 80, 0], heights: [20, 0, 20, 0, 20, 0], headerRows: 0, body: ResponsavelFinanceiro() },
				layout: 'noBorders',
			};
		}
		function tableEndereco() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', 150, 80, 80, 0], heights: [30, 0, 30, 0, 30, 0], headerRows: 0, body: Endereco() },
				layout: 'noBorders',
			};
		}
		function tableTitular() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', 150, 80, 80, 0], heights: [30, 0, 30, 0, 30, 0], headerRows: 0, body: Titular() },
				layout: 'noBorders',
			};
		}
		function tableDependentes() {
			return {
				style: 'tableEstilo',
				table: {
					widths: ['*', 150, 80, 80, 0],
					heights: function (row) {
						if (row === 0) return 20;
						if (row % 7 === 0) return 12;
						return (row % 2 !== 0) ? 14 : 20;
					},
					headerRows: 0,
					body: Dependentes(),
				},
				layout: 'noBorders',
			};
		}	
		function tableInfoPlano() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', '*', '*', '*'], heights: [30, 0, 30, 0], headerRows: 0, body: InfoPlano() },
				layout: 'noBorders',
			};
		}
		function tableCarencia() {
			let corpoTabela = Carencia();
			return {
				style: 'tableEstilo',
				table: {
					widths: [320, 180],
					heights: function (row) { return row === 0 ? 20 : 30; },
					headerRows: 0,
					body: corpoTabela,
				},
				layout: 'noBorders',
			};
		}
		function tableCorretora() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', 250, 150], heights: [30, 0, 30, 0], headerRows: 0, body: Corretora() },
				layout: 'noBorders',
			};
		}
		function tableDadosFinanceiro() {
			if (vendas.planServer) {
				return {};
			} else {
				return {
					style: 'tableEstilo',
					table: { widths: ['*', 250, 150], heights: [30, 0, 30, 0], headerRows: 0, body: DadosFinanceiros() },
					layout: 'noBorders',
				};			
			}
		}
		function tableDocumentos() {
			return {
				style: 'tableEstilo',
				table: { widths: ['*', 250, 150], heights: [30, 0, 30, 0], headerRows: 0, body: Documentos() },
				layout: 'noBorders',
			};
		}

		const documentDefinition = {
			pageSize: 'A4',
			pageOrientation: 'portrait',
			pageMargins: [40, 100, 40, 60],
			header: function () {
				return [
					{
						alignment: 'justify',
						columns: [
							{ image: 'logo_dental', width: 150, style: 'logo' },
							{
								stack: [
									{ text: 'RESUMO DA PROPOSTA ', style: 'header' },
									{ text: plan.tradeName , style: 'subheader' },
									{ text: " STATUS : " + dados.sales.status, style: 'subheader' },
								],
							}
						]
					},
				];
			},
			footer(currentPage, pageCount) {
				return {
					layout: 'noBorders',
					margin: [40, 20, 40, 22],
					table: {
						widths: ['auto'],
						body: [
							[{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 }],
							[[{ text: `Página ${currentPage.toString()} de ${pageCount}`, fontSize: 8, alignment: 'right', margin: [3, 0] }]],
						],
					},
				};
			},
			content: [
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableResponsavel(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableEndereco(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableTitular(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableDependentes(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableInfoPlano(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableCarencia(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableCorretora(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableDadosFinanceiro(),
				{ text: '___________________________________________________________________________________________________________________________________________________________________________________________________________________________________', alignment: 'center', fontSize: 5 },
				tableDocumentos()
			],
			images: {
				logo_dental: {
					url: urlBase.client + 'assets/images2/new_layout/logo_dental.png'
				}
			},
			styles: {
				header: { fontSize: 16, bold: true, alignment: 'left', margin: [80, 40, 40, 0], color: '#d51125' },
				footer: { fontSize: 12, bold: false, alignment: 'right', margin: [0, 23, 40, 0] },
				subheader: { fontSize: 10, bold: true, alignment: 'left', margin: [80, 0, 40, 0], color: '#696969' },
				tableHeader: { fontSize: 12, italics: false, bold: true, color: '#000000', fillColor: '#aeaaa9' },
				logo: { alignment: 'left', margin: [40, 20, 0, 0] },
				styleTitulo: { fontSize: 12, bold: false, alignment: 'center', color: '#696969', border: [false, false, false, false] },
				styleCampo: { fontSize: 10, bold: true, alignment: 'left', color: '#d31a25', border: [true, true, true, true] },
				styleDados: { fontSize: 9, bold: false, alignment: 'left', color: '#696969', border: [true, true, true, true] },
				styleCarenciaTitulo: { fontSize: 10, bold: true, alignment: 'center', color: '#ffffff', fillColor: '#d31a25' },
				styleCarenciaDados1: { fontSize: 10, bold: true, alignment: 'center', color: '#d31a25', fillColor: '#EEEDEB' },
				styleCarenciaDados2: { fontSize: 10, bold: true, alignment: 'center', color: '#d31a25', fillColor: '#E3E0DD' },
				tableEstilo: { fontSize: 10, margin: [0, 5, 0, 15], border: [false, false, false, false] },
				styleSemDados: { fontSize: 10, bold: true, alignment: 'center', color: '#d31a25', border: [true, true, true, true] },
			},
		};

		if (tipo == 'download') {
			pdfMake.createPdf(documentDefinition).download('resumo-proposta-pf.pdf');
		} else {
			pdfMake.createPdf(documentDefinition).open();
		}
	}

	// Execução via Promise tradicional (compatível com React 15 e sem usar async/await)
	if (planosCorrelacionados.length === 0) {
		fetch(url)
			.then(response => {
				if (response.ok) {
					return response.json();
				}
				return [];
			})
			.then(data => {
				prosseguirGeracao(data);
			})
			.catch(error => {
				console.error("Erro ao buscar planos automaticamente para o PDF:", error);
				prosseguirGeracao([]);
			});
	} else {
		prosseguirGeracao(planosCorrelacionados);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/relatorio/resumo_proposta_pf.js
 **/